import style from "./dialog-close-button.module.css";

export function CloseButton({
  onClick,
  testid,
  ariaLabel = "Close",
}: {
  onClick: () => void;
  testid?: string;
  ariaLabel?: string;
}) {
  return (
    <button aria-label={ariaLabel} className={style.closeButton} onClick={onClick} data-testid={testid}>
      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1 L9 9M1 9L9 1" stroke="#848199" strokeWidth="0.83" strokeLinecap="round" />
      </svg>
    </button>
  );
}
